"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTradePwdWithDynCodeRequest = void 0;
var ResetTradePwdWithDynCodeRequest = /** @class */ (function () {
    function ResetTradePwdWithDynCodeRequest() {
    }
    return ResetTradePwdWithDynCodeRequest;
}());
exports.ResetTradePwdWithDynCodeRequest = ResetTradePwdWithDynCodeRequest;
;
//# sourceMappingURL=resetTradePwdWithDynCode.request.js.map